module.exports = __webpack_public_path__ + "img/959-c386e4.png";